import React from "react";
import { Link } from "react-router-dom";
import { Percent, Receipt, BadgeCheck, DoorOpen, Home, ShieldCheck, LineChart } from "lucide-react";

// Guide più cercate: ogni etichetta punta alla pagina/articolo esistente che tratta meglio il tema.
// "Aprire un agriturismo" NON è incluso: non esiste ancora una pagina dedicata.
const GUIDE = [
  { label: "Cedolare secca affitti brevi", to: "/blog/cedolare-secca-26-gettito-17-milioni-dati-2025", Icon: Percent },
  { label: "Imposta di soggiorno", to: "/blog/rendicontazione-imposta-soggiorno-tool-gratuito-host", Icon: Receipt },
  { label: "Codice CIN", to: "/servizi/cin-facile", Icon: BadgeCheck },
  { label: "Come aprire un B&B", to: "/servizi/inizia-avventura", Icon: DoorOpen },
  { label: "Come aprire una casa vacanze", to: "/servizi/inizia-avventura", Icon: Home },
  { label: "Alloggiati Web", to: "/blog/conservare-documenti-ospiti-illegale-guida-host", Icon: ShieldCheck },
  { label: "Gestione affitti brevi", to: "/servizi", Icon: LineChart },
];

export default function HomeGuideLinks() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-8 pb-16 font-figtree" data-testid="home-guide-piu-cercate">
      <div className="rounded-[26px] p-6 md:p-10" style={{ background: "#F6F7F9", border: "1px solid #ECEEF1" }}>
        <span className="inline-block font-bold text-[12px] uppercase tracking-[0.12em] mb-3" style={{ color: "#EA580C" }}>
          Guide
        </span>
        <h2 className="font-bricolage font-extrabold m-0 text-[28px] md:text-[34px]" style={{ letterSpacing: "-0.02em", color: "#111318", lineHeight: 1.1 }}>
          Le guide più cercate dagli host
        </h2>
        <p className="mt-2 mb-0 text-[15px] md:text-[16px]" style={{ color: "#4A505B", maxWidth: 620 }}>
          Le risposte pratiche su normative, tasse e gestione, spiegate da host per host.
        </p>

        <div className="flex flex-wrap gap-2.5 md:gap-3 mt-6">
          {GUIDE.map(({ label, to, Icon }, i) => (
            <Link
              key={label}
              to={to}
              data-testid={`home-guide-tag-${i}`}
              className="group inline-flex items-center gap-2.5 rounded-full bg-white border border-[#E4E6EA] hover:border-[#111318] hover:-translate-y-0.5 pl-2 pr-5 py-2 transition-[transform,border-color] duration-150"
            >
              <span
                className="flex-none w-9 h-9 rounded-full flex items-center justify-center transition-colors duration-150 group-hover:bg-[#EA580C] group-hover:text-white"
                style={{ background: "#FFF1E7", color: "#EA580C" }}
              >
                <Icon size={18} />
              </span>
              <span className="font-bold text-[14px] md:text-[15px]" style={{ color: "#111318" }}>{label}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
